import jwt_decode from 'jwt-decode'
import swal from 'sweetalert'
import { privateAPI } from '../../config/constants'
import { decrypt, gettokenData } from '../../functions/globalFunctions'
import * as generalTypes from '../types/generalTypes'

let tokenData
if (localStorage.getItem('token')) {
  let token = jwt_decode(localStorage.getItem('token'))
  tokenData = decrypt(token.data)
}
export const getProductCampaignFiltersOffline = () => {
  return async (dispatch) => {
    const res = await privateAPI.post(`offline/get-product-filters`)
    if (res) {
      dispatch({
        type: generalTypes.OFFLINE_PRODUCT_FILTERS,
        payload: decrypt(res.data),
      })
    }
  }
}

export const getInvoicesByFilterOffline = (data) => {
  return async (dispatch) => {
    const payload = {
      data,
      vendorId: gettokenData()?.vendorId,
    }

    const res = await privateAPI.post(`/offline/get-users-by-filter`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)
      if (resp.result.length > 0) {
        dispatch({
          type: generalTypes.OFFLINE_FILTERED_USERS,
          payload: resp.result,
        })
      } else {
        swal('', 'No Users for this Selection', 'info')
      }
    }
  }
}

export const getProductCampaignFiltersOnline = () => {
  return async (dispatch) => {
    const res = await privateAPI.get(`/online/get-product-filters/${tokenData?.vendorId}`)

    dispatch({
      type: generalTypes.ONLINE_PRODUCT_FILTERS,
      payload: decrypt(res.data),
    })
  }
}

export const getInvoicesByFilterOnline = (data) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/online/get-users-by-filter`, {
      data,
    })
    if (res) {
      let resp = decrypt(res.data)
      if (resp?.result?.length > 0) {
        dispatch({
          type: generalTypes.ONLINE_FILTERED_USERS,
          payload: resp.result,
        })
      } else {
        swal('', 'No Users for this Selection', 'info')
      }
    }
  }
}
export const getVendorDiscounts = (type) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/get-vendor-discounts`, {
      data: { type },
    })
    if (res) {
      dispatch({
        type: generalTypes.VENDOR_DISCOUNTS,
        payload: decrypt(res.data),
      })
    }
  }
}

export const getMonitoringNames = (channel) => {
  return async (dispatch) => {
    dispatch({
      type: generalTypes.EMPTY_MONITORING_NAMES,
    })
    const res = await privateAPI.post(`/campaign/get-monitoring-names`, {
      data: {
        channel,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: generalTypes.MONITORING_NAMES,
        payload: resp,
      })
    }
  }
}

export const getMonitorings = (campaign) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-monitorings`, {
      data: { campaign },
    })
    if (res) {
      return decrypt(res.data)
    }
  }
}
export const getPromoCodes = (id, type, tableType) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/campaign/get-promocodes`, {
      data: {
        id,
        type,
        tableType,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: generalTypes.PROMO_CODES,
        payload: resp,
      })
    }
  }
}
export const getCampaignDetails = (campaign) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-campaign-details/${campaign}`)
    if (res) {
      return decrypt(res.data)
    }
  }
}

export const getCampaignCustomer = (number, campaignId) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-campaign-customer-data`, {
      data: {
        number,
        campaignId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      return resp.orders
    }
  }
}

export const getVendorYears = () => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/get-vendor-years`)
    if (res) {
      let resp = decrypt(res.data)

      dispatch({
        type: generalTypes.SET_YEAR,
        payload: resp,
      })
    }
  }
}

export const getVendorShops = (setVendorShops) => {
  return async () => {
    const res = await privateAPI.post(`/general/get-vendor-shop-names`)
    if (res) {
      let resp = decrypt(res.data)
      setVendorShops([{ shops: 'All' }, ...resp])
    }
  }
}

export const getTempratures = (setState) => {
  return async () => {
    const res = await privateAPI.get(`/general/get-vendor-tempratures`)
    if (res) {
      let resp = decrypt(res.data)
      setState(resp)
    }
  }
}
export const getCities = (setState) => {
  return async () => {
    const res = await privateAPI.get(`/general/get-vendor-cities`)
    if (res) {
      let resp = decrypt(res.data)
      setState(resp)
    }
  }
}

export const getCustomerCluster = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-cluster`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getCustomerInsights = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-insights/color`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getCustomerInsightsCategory = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-insights/category`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getCustomerInsightsSize = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-insights/size`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getCustomerByColor = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-by-color`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getCustomerByCategory = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-by-category`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getCustomerBySize = (payload) => {
  return async () => {
    const res = await privateAPI.post(`/campaign/get-customer-by-size`, {
      data: { payload },
    })
    if (res) {
      let resp = decrypt(res.data)

      return resp
    }
  }
}

export const getWhatsappCustomers = (setWhatsappSubscribeCustomer, setCustomerLoading, value) => {
  return async () => {
    setCustomerLoading(true)

    const res = value && (await privateAPI.post('/campaign/get-whatsapp-subscribe-customer'))
    if (res) {
      setCustomerLoading(false)
      setWhatsappSubscribeCustomer(res.data)
    }
  }
}

// mutation fn
